<div class="nav-footer">
    <div class="footer-container">
        <div class="footer-links">
            <div class="footer-link">
                <a class="as-nav-title" target="_blank" role="region" aria-label="Privacy Policy" href="https://in.accenture.com/protectingaccenture/data-security/5422-2/">Privacy Policy</a>
            </div>

            <!-- <div class="footer-link" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
                <a class="as-nav-title" >Cookies Policy</a>
            </div> -->
            <div class="footer-link" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
                <a class="as-nav-title" routerLink="/termsandcondition" role="region" aria-label="Terms of Use">Terms of Use</a>

            </div>

        </div>
        <div class="footer-copyright" role="region" aria-label="Copyright 2001-2024 Accenture. All rights reserved. Accenture Confidential. For internal use only.">
          <i>Copyright &#169; 2001-2024 Accenture. All rights reserved. Accenture Confidential. For internal use only.</i>

        </div>

    </div>

</div>
